module.exports = __webpack_public_path__ + "media/images/logo_admin-52d8f1fd5c5b3328d890b46b393a6644.png";